import React from "react";
import { useModal, Modal } from 'react-morphing-modal';
import 'react-morphing-modal/dist/ReactMorphingModal.css';


function Article(props) {
  // const { modalProps, getTriggerProps } = useModal();
  const { modalProps, getTriggerProps } = useModal({
    background: '#011627',
    opacity: '50%'
  });

  return (
    <div>
        <a  className="project"
            {...getTriggerProps()}
            >
          <img className="project_img" alt="" src={props.image}>
          </img>
          <div className="middle">
            <span className="text">view </span>
          </div>
        </a>
        <Modal {...modalProps} padding={false}>
          <div className="PopUp">
              {/* x close window */}
              <div className="project_detail_container">
                  {/* <img className="pu-img" src={imgUrl} alt="bone" /> */}
                  <div className="project_detail_title">{props.title}</div> 
                  <div className="project_detail_subtitle"> {props.extract} </div>
                  <img className="content_img" alt="" src={props.project_image}></img>
                  <div className="is-5 has-text-white has-text-weight-light content_content project_content">{props.project_description}</div>
                  {/* <div className="container has-text-centered">
                    <div className="is-5 has-text-white has-text-weight-light content_content project_content">{props.project_description}</div>
                  </div> */}
              </div>
              {/* button controls */}
          </div>
        </Modal>
        <div className="project_title">{props.title}</div>
   </div>
  );
}

export default Article;
